import 'imask/esm/imask';
import { toRef, watch, h } from 'vue-demi';
import props from './props.js';
import useIMask from './composable.js';

// order does matter = priority
const VALUE_PROPS = ['typed', 'unmasked', 'value', 'modelValue'];
function _extractOptionsFromProps(props) {
  props = Object.assign({}, props);

  // keep only defined props
  Object.keys(props).filter(prop => props[prop] === undefined).forEach(undefinedProp => {
    delete props[undefinedProp];
  });
  VALUE_PROPS.forEach(p => delete props[p]);
  return props;
}
var Component3 = {
  name: 'imask-input',
  inheritAttrs: false,
  setup(props, _ref) {
    let {
      attrs,
      slots,
      emit
    } = _ref;
    const {
      el,
      mask,
      masked,
      unmasked,
      typed
    } = useIMask(_extractOptionsFromProps(props), {
      emit,
      onAccept: () => {
        // emit more events
        const v = masked.value;
        emit('accept:value', v);
        emit('update:value', v);
        emit('update:masked', v);
        emit('update:modelValue', v);
        emit('update:unmasked', unmasked.value);
        emit('update:typed', typed.value);
      },
      onComplete: () => {
        emit('complete:value', masked.value);
      }
    });
    const pvalue = toRef(props, 'value');
    const pmodelValue = toRef(props, 'modelValue');
    const punmasked = toRef(props, 'unmasked');
    const ptyped = toRef(props, 'typed');
    masked.value = pmodelValue.value || pvalue.value || '';
    unmasked.value = punmasked.value;
    typed.value = ptyped.value;
    watch(pvalue, v => masked.value = v);
    watch(pmodelValue, v => masked.value = v);
    watch(punmasked, v => unmasked.value = v);
    watch(ptyped, v => typed.value = v);
    return () => {
      const data = Object.assign({}, attrs, {
        value: props.value != null ? props.value : props.modelValue,
        ref: el
      });
      if (!props.mask) {
        data.onInput = event => {
          emit('update:modelValue', event.target.value);
          emit('update:value', event.target.value);
        };
      }
      return h('input', data);
    };
  },
  props: Object.assign({
    // plugin
    modelValue: String,
    value: String,
    unmasked: String,
    typed: {}
  }, props),
  emits: ['update:modelValue', 'update:masked', 'update:value', 'update:unmasked', 'update:typed', 'accept', 'accept:value', 'accept:masked', 'accept:unmasked', 'accept:typed', 'complete', 'complete:value', 'complete:masked', 'complete:unmasked', 'complete:typed']
};

export { Component3 as default };
